import React, { useContext, useRef } from "react";
import { FunctionComponent, MouseEvent, useEffect } from "react";
import MapCard from "./MapCard";
import useStore from "../../../hooks-store/store";
import { Partner } from "../../../api/Client";
import { localization } from "../../../localization/localizedStrings";
import { Card, Divider, Text } from "@velocity/ui";
import AppContext from "../../../context/AppContext";
interface MapCardsPanelProps {
  id?: string;
  items?: Partner[] | null | undefined;
  distance?: number;
}

const MapCardsPanel: FunctionComponent<MapCardsPanelProps> = ({
  items,
}:
MapCardsPanelProps) => {
  const appCtx = useContext(AppContext) as any;
  const selectedCardRef = useRef<HTMLDivElement | null>(null);
  const panelRef = useRef<HTMLDivElement | null>(null);

  const [, setPartnerStore] = useStore<Partner | null>(
    "partner",
    null
  );
  const [, setOpenDrawerStore] = useStore<boolean>(
    "openDrawer",
    false
  );
  const [, setInfoOpen] = useStore<boolean>("infoOpen", false);

  const handleCardClick = (
    event: MouseEvent<HTMLDivElement>,
    data: Partner | null
  ) => {
    setPartnerStore(data);
    setOpenDrawerStore(false);
    setInfoOpen(true);
    appCtx.setSelectedPartnerId(data?.id);

  };

    useEffect(() => {
        const container = panelRef.current;
        const selected = selectedCardRef.current;

        if (container && selected) {
            const containerRect = container.getBoundingClientRect();
            const selectedRect = selected.getBoundingClientRect();

            // Check if card is outside visible area
            if (
                selectedRect.top < containerRect.top ||
                selectedRect.bottom > containerRect.bottom
            ) {
                container.scrollTo({
                    top:
                        selected.offsetTop -
                        container.clientHeight / 2 +
                        selected.clientHeight / 2,
                    behavior: "smooth",
                });
            }
        }
    }, [appCtx.selectedPartnerId]);

  return (
    <Card kind="flat">
      <Card.Body>
        <div className="map-card-panel-header">
          <h4>{localization.servicePlaces}</h4>
          <Text>
            {localization.formatString(
              localization.servicePlacesDescription,
              items?.length?.toString() ?? "0"
            )}
          </Text>
          <Divider />
        </div>
        <div className="map-card-panel" ref={panelRef}>
          <div>
            {items?.map((item) => {
                const isSelected = appCtx.selectedPartnerId === item.id;
                return (
                  <div
                    key={item.id}
                    className="card-wrapper"
                    ref={
                        isSelected ? selectedCardRef : null
                    }
                  >
                    <MapCard
                      key={item.id}
                      data={item}
                      width="95%"
                      active={
                        appCtx.selectedPartnerId === item.id
                      }
                      onClick={(event: any) => handleCardClick(event, item)}
                    />
                  </div>
            )})}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MapCardsPanel;
